// extracted by mini-css-extract-plugin
export default {"root":"_3W9wk","left":"_237xG","right":"_3MB4M","author":"_2Pk77","actions":"_1tiU9"};